import { useState, useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  InputAdornment,
  Button,
  Paper,
  Stack,
  TableContainer,
  Tooltip,
  MenuItem,
  Select,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import { Creators } from "../store/ducks/config.js";
import { connect } from "react-redux";
import { styles } from "../theme/styles";
import { Badge, IconButton } from "@mui/material";
import { CustomButton } from "../components/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import Cliploader from "./Cliploader";
import CommentIcon from "@mui/icons-material/Comment";
import ComentariosModal from "./ComentariosModal.js";
import PdfReporteViewer from "./PdfReporteViewer.js";
import CamaraComponent from "./CamaraComponent.js";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

const PassForm = (props) => {
  const navigate = useNavigate();
  const { userData } = props;
  const rol = userData.rol;
  const tiendaUsuario = userData.idNumber;
  const distrito = userData.distrito;
  const [loading, setLoading] = useState(false);
  const [mongoData, setMongoData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [fechaAsc, setFechaAsc] = useState(true);
  const [TiendaAsc, setTiendaAsc] = useState(true);
  //const [mostrarViewer, setMostrarViewer] = useState(false);
  const [filteredData2, setFilteredData2] = useState([]);
  const [ordenSeleccionada, setOrdenSeleccionada] = useState("");
  const [comentarios, setComentarios] = useState({});
  const [openComentarios, setOpenComentarios] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [filtroTienda, setFiltroTienda] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedEstatuxTxt1, setSelectedEstatusTxt1] = useState("*");
  const [selectedEstatuxTxt2, setSelectedEstatusTxt2] = useState("*");
  const [selectedEstatuxTxt3, setSelectedEstatusTxt3] = useState("*");
  //**TABLA**/
  const [orderSelected, setOrderSelected] = useState("");
  const [tipoReporte, setTipoReporte] = useState("");
  const [cantComentarios, setCantComentarios] = useState(0);
  const [newMaterialSelected, setNewMaterialSelected] = useState(false);
  const [infoUpdated, setInfoUpdated] = useState(false);

  const [materialesOrden, setMaterialesOrden] = useState(null); //materiales orden
  const [erroresTabla, setErroresTabla] = useState({});
  const [rows, setRows] = useState([]);
  const [originalRows, setOriginalRows] = useState({});
  const [catalogoProblms, setCatalogoProblems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(rows.length / rowsPerPage);

  //CAMERA
  const [mostrarCamara, setMostrarCamara] = useState(false);
  const [selectedMaterialFoto, setSelectedMaterialFoto] = useState("");
  const [selectedMaterialDescrFoto, setSelectedMaterialDescrFoto] =
    useState("");
  const [evidenciasIniciales, setEvidenciasIniciales] = useState({});
  const [inicializado, setInicializado] = useState(false);
  const [dataEvidencias, setDataEvidencias] = useState(null);
  const [formData, setFormData] = useState({
    materialId: "",
    materialDescripcion: "",
    piezasPedidas: "",
    costoUnitario: "",
    facturados: "",
    cantidadRecibidos: "",
    noAptos: "",
    faltantesFacturados: "",
    faltantesNoFacturados: "",
    problemasEnRecepcion: "",
    diagnostico: "",
    tratamiento: "",
    comentariosGenerales: "",
    manual: true,
  });
  const [errorFormData, setErrorFormData] = useState({
    materialId: false,
    materialDescripcion: false,
    piezasPedidas: false,
    costoUnitario: false,
    facturados: false,
    cantidadRecibidos: false,
    noAptos: false,
    faltantesFacturados: false,
    faltantesNoFacturados: false,
    problemasEnRecepcion: false,
    diagnostico: false,
    tratamiento: false,
    comentariosGenerales: false,
  });
  const [viewDisclaimerOpen, setViewDisclaimerOpen] = useState(false);
  /*console.log("VIEW MODAL", viewModal);
  console.log("MATERIALES ORDEN", materialesOrden);
  console.log("CURRENT ROWS", currentRows);
  console.log("ROWS", rows);
  console.log("TIPO REPORTE", tipoReporte);
  console.log("ROL", rol);
  console.log("FILTERED DATA", filteredData2);*/
  //console.log("FORM DATA", formData);
  //console.log("ERROR FORM DATA", errorFormData);

  /*const filteredData = useMemo(() => {
    return mongoData.filter(
      (item) =>
        item.idOrder.includes(searchTerm) ||
        item.tiendaDestino.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.proveedorText.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.fechaRecepcion.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.noemp.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [mongoData, searchTerm]);*/

  const filteredData = useMemo(() => {
    return mongoData;
  }, [mongoData]);

  useEffect(() => {
    setFilteredData2(filteredData);
  }, [filteredData]);

  const datosPorRol = (() => {
    let result;
    if (rol === "ADMIN" || rol === "SUPERVISOR") {
      result = filtroTienda
        ? filteredData2.filter((item) => item.tiendaDestino === filtroTienda)
        : filteredData2;
    } else if (rol === "PROVIDER") {
      result = filteredData2.filter(
        (item) =>
          Number(item.proveedorId) === Number(tiendaUsuario) &&
          (item.estatusTxt1 === "ACEPTADO" ||
            item.estatusTxt2 === "ACEPTADO" ||
            item.estatusTxt3 === "ACEPTADO"),
      );
    } else if (rol === "GPI") {
      result = filtroTienda
        ? filteredData2.filter((item) => item.tiendaDestino === filtroTienda)
        : filteredData2;
    } else {
      result = filteredData2;
    }
    return result;
  })();

  const tiendasUnicas = [
    ...new Set(datosPorRol.map((item) => item.tiendaDestino)),
  ];
  const proveedoresUnicos = [
    ...new Set(datosPorRol.map((item) => item.proveedorText)),
  ];

  const mapDisplayTxt = (valor) => {
    if (!valor) {
      return rol === "STORE" ? "GENERAR" : "NO SE HA GENERADO";
    }
    return valor;
  };

  const getUniqueEstatus = (field) => {
    const rawValues = [...new Set(datosPorRol.map((item) => item[field]))];

    return rawValues.map((valor) => ({
      value: valor,
      label: mapDisplayTxt(valor),
    }));
  };

  const estatuxTxt1Unicos = getUniqueEstatus("estatusTxt1");
  const estatuxTxt2Unicos = getUniqueEstatus("estatusTxt2");
  const estatuxTxt3Unicos = getUniqueEstatus("estatusTxt3");

  const term = searchTerm.trim().toLowerCase();
  const isManualSearch = term === "manual";

  const dataReportesFilter = datosPorRol.filter((c) => {
    const tiendaMatch = filtroTienda === "" || c.tiendaDestino === filtroTienda;
    const proveedorMatch =
      selectedProveedor === "" || c.proveedorText === selectedProveedor;

    const estatusTxt1Match =
      selectedEstatuxTxt1 === "*" || c.estatusTxt1 === selectedEstatuxTxt1;
    const estatusTxt2Match =
      selectedEstatuxTxt2 === "*" || c.estatusTxt2 === selectedEstatuxTxt2;
    const estatusTxt3Match =
      selectedEstatuxTxt3 === "*" || c.estatusTxt3 === selectedEstatuxTxt3;

    const manualMatch = !isManualSearch || c.tieneManual === true;
    const searchMatch = isManualSearch
      ? true
      : (c.idOrder?.toString().toLowerCase() || "").includes(term) ||
        (c.tiendaDestino?.toLowerCase() || "").includes(term) ||
        (c.proveedorText?.toLowerCase() || "").includes(term) ||
        (c.estatusTxt1?.toLowerCase() || "").includes(term) ||
        new Date(c.fechaCreacion)
          .toLocaleString("es-MX", {
            dateStyle: "short",
            timeStyle: "medium",
          })
          .toLowerCase()
          .includes(term);

    return (
      tiendaMatch &&
      proveedorMatch &&
      estatusTxt1Match &&
      estatusTxt2Match &&
      estatusTxt3Match &&
      manualMatch &&
      searchMatch
    );
  });
  const ordenarPorFecha = () => {
    const aux = [...filteredData2].sort((a, b) => {
      const fechaA = parseFecha(a.fechaRecepcion);
      const fechaB = parseFecha(b.fechaRecepcion);
      return fechaAsc ? fechaA - fechaB : fechaB - fechaA;
    });
    setFilteredData2(aux);
    setFechaAsc(!fechaAsc);
  };

  const ordenarPorTienda = () => {
    const aux = [...filteredData2].sort((a, b) => {
      const tiendaA = a.tiendaDestino;
      const tiendaB = b.tiendaDestino;
      return TiendaAsc
        ? tiendaA.localeCompare(tiendaB)
        : tiendaB.localeCompare(tiendaA);
    });
    setFilteredData2(aux);
    setTiendaAsc(!TiendaAsc);
  };

  const columns = [
    "MATERIALES",
    "DESCRIPCIÓN DE MATERIAL",
    "PIEZAS PEDIDAS",
    "COSTO UNITARIO",
    //"FACTURADOS",

    //"NO APTOS A LA RECEPCIÓN",
    //"FALTANTES FACTURADOS",
    "TOTALES A INGRESAR",

    "PROBLEMAS",
    "NO APTOS A LA RECEPCIÓN",
    "PROBLEMAS EN RECEPCION",
    "DIAGNOSTICO",
    "TRATAMIENTO",
    "COMENTARIOS GENERALES",
  ];

  const columns2 = [
    "materialId",
    "materialDescripcion",
    "piezasPedidas",
    "costoUnitario",

    //"noAptos",
    "cantidadRecibidos",

    "problemas",
    "noAptos",
    "problemasEnRecepcion",
    "diagnostico",
    "tratamiento",
    "comentariosGenerales",
    "manual",
  ];

  const parseFecha = (fechaStr) => {
    const [dia, mes, anio] = fechaStr.split("/");
    return new Date(`${anio}-${mes}-${dia}`);
  };

  const getAllOrdenesMongo = async () => {
    try {
      setLoading(true);
      const payload = { rol, userLogueado: tiendaUsuario };
      if (rol === "SUPERVISOR") {
        payload.distrito = distrito;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getAllOrdenesMongo`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
          },
        },
      );
      setMongoData(data.data || []);
      setFilteredData2(data.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener órdenes:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!rol) return;
    if (rol === "SUPERVISOR" && !distrito) return;
    getAllOrdenesMongo();
  }, [rol, distrito]);

  useEffect(() => {
    if (!inicializado && dataEvidencias?.evidencias) {
      const inicial = {};
      dataEvidencias.evidencias.forEach((e) => {
        inicial[e.material] = e.fotos.length; // cuántas fotos tenía cada material
      });
      setEvidenciasIniciales(inicial);
      setInicializado(true);
    }
  }, [dataEvidencias, inicializado]);

  const descargarReportes = async (idOrder) => {
    try {
      // Primer archivo
      const response1 = await axios.get(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getReporteExcel/${idOrder}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: process.env.REACT_APP_APIKEY,
          },
          responseType: "blob",
        },
      );
      const url1 = window.URL.createObjectURL(new Blob([response1.data]));
      const link1 = document.createElement("a");
      link1.href = url1;
      link1.setAttribute("download", `reporte_${idOrder}.xlsx`);
      document.body.appendChild(link1);
      link1.click();
      link1.remove();
      window.URL.revokeObjectURL(url1);

      // Segundo archivo (Evidencias)
      const response2 = await axios.get(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getReporteExcelEvidencias/${idOrder}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: process.env.REACT_APP_APIKEY,
          },
          responseType: "blob",
        },
      );
      const url2 = window.URL.createObjectURL(new Blob([response2.data]));
      const link2 = document.createElement("a");
      link2.href = url2;
      link2.setAttribute("download", `reporte_${idOrder}_Evidencias.xlsx`);
      document.body.appendChild(link2);
      link2.click();
      link2.remove();
      window.URL.revokeObjectURL(url2);
    } catch (error) {
      console.log("Error descargando reportes: ", error);
      Swal.fire({
        icon: "error",
        title: "Error al descargar",
        text: "Ocurrió un error al descargar los archivos. Intenta nuevamente.",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const getEstatusStyles = (estatus) => {
    if (rol === "PROVIDER" && estatus !== "ACEPTADO") {
      return { backgroundColor: "#ffffff", color: "#000000" };
    }
    switch (estatus) {
      case "EN PROCESO":
        return { backgroundColor: "#cce4ff", color: "#003366" };
      case "POR REVISAR":
        return { backgroundColor: "#fff3b0", color: "#665500" };
      case "ACEPTADO":
        return { backgroundColor: "#d4edda", color: "#155724" };
      case "RECHAZADO":
        return { backgroundColor: "#f8d7da", color: "#721c24" };
      case "VENCIDO":
        return { backgroundColor: "#C9C9C9", color: "white" };
      default:
        return { backgroundColor: "#ffffff", color: "#000000" };
    }
  };

  const handleViewDisclaimer = (orderId, tipoReporte) => {
    setViewDisclaimerOpen(true);
    setOrdenSeleccionada(orderId);
    setTipoReporte(tipoReporte);
  };

  const handleCloseDisclaimer = () => {
    setViewDisclaimerOpen(false);
    setTipoReporte("");
  };

  /*********MODAL********/
  const getOrdenInfo = async (numeroOrden) => {
    if (!numeroOrden) return;
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getInfoOrderMongo`,
        { idOrder: numeroOrden },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      setMaterialesOrden(response.data.data.jsonInformacion);
      let versionEvidenciaActual = response.data.data.evidencias;
      setDataEvidencias({
        ...response.data,
        evidencias: versionEvidenciaActual ? versionEvidenciaActual : [],
      });
    } catch (error) {
      console.error("Error al obtener info de la orden:", error);
    } finally {
      setLoading(false);
    }
  };

  const createEmptyRow = (item) => ({
    materialId: item.materialId || "",
    materialDescripcion: item.materialDescripcion || "",
    piezasPedidas: item.piezasPedidas || "",
    costoUnitario: item.costoUnitario || "",
    facturados: item.facturados || "",
    cantidadRecibidos: item.cantidadRecibidos ?? "",
    noAptos: item.noAptos || "",
    faltantesFacturados: item.faltantesFacturados || "",
    faltantesNoFacturados: item.faltantesNoFacturados || "",
    problemasEnRecepcion: item.problemasEnRecepcion || "",
    diagnostico: item.diagnostico || "",
    tratamiento: item.tratamiento || "",
    comentariosGenerales: item.comentariosGenerales || "",
    manual: item.manual === true,
    habilitarEdicion: false,
  });

  useEffect(() => {
    if (!materialesOrden || materialesOrden.length === 0) {
      setRows([]);
      return;
    }
    const mappedRows = materialesOrden.map((item) => createEmptyRow(item));
    setRows(mappedRows);
    setOriginalRows(JSON.parse(JSON.stringify(mappedRows)));
  }, [materialesOrden]);

  const getProblemsCatalogo = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_PETCOZOO}/problematicas/getAllProblematicas`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      setCatalogoProblems(data.data);
    } catch (error) {
      console.log("Error al obtener problemas", error);
    }
  };

  useEffect(() => {
    getProblemsCatalogo();
  }, []);

  const handleChange = (indexInPage, field, value) => {
    const globalIndex = indexOfFirstRow + indexInPage;

    const numericFields = [
      "materialId",
      "piezasPedidas",
      "costoUnitario",
      "cantidadRecibidos",
      "noAptos",
    ];

    if (numericFields.includes(field) && !/^$|^\d+$/.test(value)) return;
    const decimalFields = ["piezasPedidas", "costoUnitario"];
    if (decimalFields.includes(field) && !/^\d*\.?\d*$/.test(value)) return;

    const updated = [...rows];
    updated[globalIndex] = { ...updated[globalIndex], [field]: value };

    const newErrores = { ...erroresTabla };
    const row = updated[globalIndex];
    const cantidadRecibidosCalc =
      Number(row.facturados || 0) -
      (Number(row.noAptos || 0) + Number(row.faltantesFacturados || 0));

    if (cantidadRecibidosCalc < 0) {
      Swal.fire({
        icon: "warning",
        title: "Dato inválido",
        text: "El total a ingresar no puede ser negativo. Por favor revisa el valor ingresado.",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });

      updated[globalIndex][field] = "";

      const recalculated =
        Number(updated[globalIndex].facturados || 0) -
        (Number(updated[globalIndex].noAptos || 0) +
          Number(updated[globalIndex].faltantesFacturados || 0));

      updated[globalIndex].cantidadRecibidos = String(
        recalculated >= 0 ? recalculated : 0,
      );
      setRows(updated);
      return;
    }

    row.cantidadRecibidos = String(cantidadRecibidosCalc);
    if (value && value.toString().trim() !== "") {
      delete newErrores[`${globalIndex}-${field}`];
    } else {
      newErrores[`${globalIndex}-${field}`] = true;
    }

    if (field === "noAptos") {
      const dependientes = [
        "problemasEnRecepcion",
        "diagnostico",
        "tratamiento",
        "comentariosGenerales",
      ];
      if (
        !value ||
        value.toString().trim() === "" ||
        value.toString().trim() === "0"
      ) {
        dependientes.forEach(
          (campo) => delete newErrores[`${globalIndex}-${campo}`],
        );
      } else {
        dependientes.forEach((campo) => {
          if (!row[campo] || row[campo].toString().trim() === "") {
            newErrores[`${globalIndex}-${campo}`] = true;
          }
        });
      }
    }

    if (
      [
        "problemasEnRecepcion",
        "diagnostico",
        "tratamiento",
        "comentariosGenerales",
      ].includes(field)
    ) {
      if (
        row.noAptos &&
        (row.noAptos.toString().trim() !== "" ||
          row.noAptos.toString().trim() !== "0")
      ) {
        if (value && value.toString().trim() !== "") {
          delete newErrores[`${globalIndex}-${field}`];
        } else {
          newErrores[`${globalIndex}-${field}`] = true;
        }
      } else {
        delete newErrores[`${globalIndex}-${field}`];
      }
    }

    if (field === "problemasEnRecepcion") {
      const dependientes = [
        "diagnostico",
        "tratamiento",
        "comentariosGenerales",
      ];
      if (!value || value.toString().trim() === "") {
        dependientes.forEach(
          (campo) => delete newErrores[`${globalIndex}-${campo}`],
        );
      } else {
        dependientes.forEach((campo) => {
          if (!row[campo] || row[campo].toString().trim() === "") {
            newErrores[`${globalIndex}-${campo}`] = true;
          }
        });
      }
    }

    if (
      ["diagnostico", "tratamiento", "comentariosGenerales"].includes(field)
    ) {
      if (
        row.problemasEnRecepcion &&
        row.problemasEnRecepcion.toString().trim() !== ""
      ) {
        if (value && value.toString().trim() !== "") {
          delete newErrores[`${globalIndex}-${field}`];
        } else {
          newErrores[`${globalIndex}-${field}`] = true;
        }
      } else {
        delete newErrores[`${globalIndex}-${field}`];
      }
    }

    const isManual = row.manual === true;
    const obligatorios = isManual
      ? ["materialId", "materialDescripcion", "piezasPedidas", "costoUnitario"]
      : ["piezasPedidas"];

    obligatorios.forEach((campo) => {
      if (!row[campo] || row[campo].toString().trim() === "") {
        newErrores[`${globalIndex}-${campo}`] = true;
      } else {
        delete newErrores[`${globalIndex}-${campo}`];
      }
    });

    setRows(updated);
    setErroresTabla(newErrores);
  };

  const handleCheckboxChange = (rowIndex, checked) => {
    const globalIndex = indexOfFirstRow + rowIndex;
    const updated = [...rows];
    updated[globalIndex].habilitarEdicion = checked;
    setRows(updated);

    if (!checked) {
      setRows((prev) => {
        const copy = [...prev];
        copy[globalIndex] = {
          ...originalRows[globalIndex],
          habilitarEdicion: false,
        };
        return copy;
      });
    }
  };

  const openUpdateReporte = async (idOrder, numReporte) => {
    setViewModal(true);
    setOrderSelected(idOrder);
    setTipoReporte(numReporte);
    await getOrdenInfo(idOrder);
  };

  const closeUpdateReporte = async () => {
    setViewModal(false);
    setOrderSelected("");
    setTipoReporte("");
    setInfoUpdated(false);
    setNewMaterialSelected(false);
    setSelectedMaterialFoto("");
    setSelectedMaterialDescrFoto("");
    setErroresTabla({});
    setFormData({
      materialId: "",
      materialDescripcion: "",
      piezasPedidas: "",
      costoUnitario: "",
      facturados: "",
      cantidadRecibidos: "",
      noAptos: "",
      faltantesFacturados: "",
      faltantesNoFacturados: "",
      problemasEnRecepcion: "",
      diagnostico: "",
      tratamiento: "",
      comentariosGenerales: "",
      manual: true,
    });
    setErrorFormData({
      materialId: false,
      materialDescripcion: false,
      piezasPedidas: false,
      costoUnitario: false,
      facturados: false,
      cantidadRecibidos: false,
      noAptos: false,
      faltantesFacturados: false,
      faltantesNoFacturados: false,
      problemasEnRecepcion: false,
      diagnostico: false,
      tratamiento: false,
      comentariosGenerales: false,
    });
  };

  useEffect(() => {
    getOrdenInfo();
  }, [mostrarCamara]);

  const validateTable = (rows) => {
    const erroresPorCelda = {};
    let hayErrores = false;

    rows.forEach((row, rowIndex) => {
      const isManual = row.manual === true;
      const obligatorios = isManual
        ? ["materialId", "piezasPedidas", "costoUnitario"]
        : ["facturados"];

      obligatorios.forEach((campo) => {
        if (!row[campo] || row[campo].toString().trim() === "") {
          hayErrores = true;
          erroresPorCelda[`${rowIndex}-${campo}`] = true;
        }
      });

      if (row.habilitarEdicion) {
        if (
          !row.noAptos ||
          row.noAptos.toString().trim() === "" ||
          row.noAptos.toString().trim() === "0"
        ) {
          hayErrores = true;
          erroresPorCelda[`${rowIndex}-noAptos`] = true;
          return;
        }

        // Si seleccionan no aptos
        if (
          row.noAptos &&
          (row.noAptos.toString().trim() !== "" ||
            row.noAptos.toString().trim() !== "0")
        ) {
          [
            "problemasEnRecepcion",
            "diagnostico",
            "tratamiento",
            "comentariosGenerales",
          ].forEach((campo) => {
            if (!row[campo] || row[campo].toString().trim() === "") {
              hayErrores = true;
              erroresPorCelda[`${rowIndex}-${campo}`] = true;
            }
          });
        }
      }
    });

    if (hayErrores) {
      Swal.fire({
        icon: "warning",
        title: "Campos vacíos",
        text: "Por favor, llena todos los campos antes de continuar.",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
        width: 500,
      });
      return erroresPorCelda;
    }

    return null;
  };

  const handleSaveData = async (e) => {
    e.preventDefault();
    if (!rows || !rows.length === 0) {
      return;
    }

    const errores = validateTable(rows);
    if (errores) {
      setErroresTabla(errores);
      return;
    }
    setErroresTabla({});
    try {
      setLoading(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/updateInfoOrder/${tipoReporte}`,
        {
          idOrder: orderSelected,
          jsonInformacion: rows,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      setLoading(false);
      setInfoUpdated(true);
    } catch (error) {
      console.log("error guardando info de tabla: ", error);
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Fallo al guardar la información. Intente de nuevo",
        icon: "error",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const handleFormMaterial = (e) => {
    const { name, value } = e.target;
    const numericFields = [
      "materialId",
      "facturados",
      "cantidadRecibidos",
      "noAptos",
      "faltantesFacturados",
      "faltantesNoFacturados",
    ];
    const decimalFields = ["piezasPedidas", "costoUnitario"];

    if (numericFields.includes(name) && !/^$|^\d+$/.test(value)) {
      return;
    }

    if (decimalFields.includes(name) && !/^\d*\.?\d*$/.test(value)) {
      return;
    }

    const valoresDinamicos = ["facturados", "noAptos", "faltantesFacturados"];
    const calcularCantidadRecibidos = (data) =>
      Number(data.facturados || 0) -
      (Number(data.noAptos || 0) + Number(data.faltantesFacturados || 0));
    if (valoresDinamicos.includes(name)) {
      const updated = { ...formData, [name]: value };
      let cantidadRecibidosCalc = calcularCantidadRecibidos(updated);

      if (cantidadRecibidosCalc < 0) {
        Swal.fire({
          icon: "warning",
          title: "Dato inválido",
          text: "El total a ingresar no puede ser negativo. Por favor revisa el valor ingresado.",
          confirmButtonColor: "#00205B",
          confirmButtonText: "Aceptar",
        });
        const cleaned = { ...formData, [name]: "" };

        cantidadRecibidosCalc = calcularCantidadRecibidos(cleaned);
        setFormData(() => {
          const updatedClean = {
            ...cleaned,
            cantidadRecibidos: String(Math.max(cantidadRecibidosCalc, 0)),
          };
          validateForm(false, updatedClean);
          return updatedClean;
        });
        return;
      }
      setFormData((prev) => {
        const updatedValid = {
          ...prev,
          [name]: value,
          cantidadRecibidos: String(cantidadRecibidosCalc),
        };
        validateForm(false, updatedValid);
        return updatedValid;
      });
      return;
    }
    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      validateForm(false, updated);
      return updated;
    });
  };

  const handleBuscarDescripcion = async () => {
    if (!formData.materialId) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getMaterialDescripcion/${formData.materialId}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.data.data.MATERIAL_NOMBRE) {
        setFormData((prev) => ({
          ...prev,
          materialDescripcion: response.data.data.MATERIAL_NOMBRE,
        }));
      } else {
        Swal.fire({
          icon: "warning",
          title: "Material no encontrado",
          text: `No existe la descripción para el ID: ${formData.materialId}`,
          confirmButtonColor: "#00205B",
          confirmButtonText: "Aceptar",
        });
        setFormData((prev) => ({
          ...prev,
          materialDescripcion: "",
        }));
      }
    } catch (error) {
      console.error("Error al buscar descripción:", error);
      setFormData((prev) => ({
        ...prev,
        materialDescripcion: "",
      }));
      if (error) {
        if (error.response) {
          Swal.fire({
            title: error.response.data.error,
            text: "Inténtalo de nuevo",
            icon: "error",
            confirmButtonColor: "#001F5B",
            confirmButtonText: "Aceptar",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error de conexión",
            text: "No se pudo obtener la descripción del material.",
            confirmButtonColor: "#00205B",
            confirmButtonText: "Aceptar",
          });
        }
      }
    }
  };

  const validateForm = (showAlert = true, data = formData) => {
    const newErrors = {};
    let hasError = false;
    for (const field in data) {
      const value = data[field]?.toString().trim() ?? "";
      if (
        field !== "problemasEnRecepcion" &&
        field !== "noAptos" &&
        field !== "diagnostico" &&
        field !== "tratamiento" &&
        field !== "comentariosGenerales" &&
        field !== "faltantesFacturados" &&
        field !== "cantidadRecibidos" &&
        field !== "faltantesNoFacturados" &&
        (value === "" || value === null)
      ) {
        newErrors[field] = true;
      } else {
        newErrors[field] = false;
      }
    }

    if (Number(data.noAptos) > 0) {
      if (!data.problemasEnRecepcion?.trim())
        newErrors.problemasEnRecepcion = true;
      if (!data.tratamiento?.trim()) newErrors.tratamiento = true;
      if (!data.diagnostico?.trim()) newErrors.diagnostico = true;
      if (!data.comentariosGenerales?.trim())
        newErrors.comentariosGenerales = true;
    }

    if (data.problemasEnRecepcion?.trim()) {
      if (!data.tratamiento?.trim()) newErrors.tratamiento = true;
      if (!data.diagnostico?.trim()) newErrors.diagnostico = true;
      if (!data.comentariosGenerales?.trim())
        newErrors.comentariosGenerales = true;
    }

    hasError = Object.values(newErrors).some((v) => v === true);
    setErrorFormData(newErrors);
    if (hasError && showAlert) {
      Swal.fire({
        icon: "error",
        title: "Faltan datos",
        text: "Favor de llenar los datos faltantes",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
      });
    }
    return !hasError;
  };

  const handleSaveMaterial = async (e) => {
    if (!validateForm(true)) return;
    try {
      setLoading(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/addMaterialOrder/${tipoReporte}`,
        {
          idOrder: orderSelected,
          newMaterial: formData,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      setLoading(false);
      setNewMaterialSelected(false);
      getOrdenInfo(orderSelected);
      setFormData({
        materialId: "",
        materialDescripcion: "",
        piezasPedidas: "",
        costoUnitario: "",
        facturados: "",
        cantidadRecibidos: "",
        noAptos: "",
        faltantesFacturados: "",
        faltantesNoFacturados: "",
        problemasEnRecepcion: "",
        diagnostico: "",
        tratamiento: "",
        comentariosGenerales: "",
        manual: true,
      });
      setErrorFormData({
        materialId: false,
        materialDescripcion: false,
        piezasPedidas: false,
        costoUnitario: false,
        facturados: false,
        cantidadRecibidos: false,
        noAptos: false,
        faltantesFacturados: false,
        faltantesNoFacturados: false,
        problemasEnRecepcion: false,
        diagnostico: false,
        tratamiento: false,
        comentariosGenerales: false,
      });
    } catch (error) {
      console.log("error", error);
      setLoading(false);
      if (error) {
        if (error.response) {
          Swal.fire({
            title: "Error",
            text: error.response.data.error,
            icon: "error",
            confirmButtonColor: "#001F5B",
            confirmButtonText: "Aceptar",
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Error al agregar material. Intente de nuevo",
            icon: "error",
            confirmButtonColor: "#00205B",
            confirmButtonText: "Aceptar",
          });
        }
      }
    }
  };

  const tieneFotoNueva = (materialId) => {
    const iniciales = evidenciasIniciales[materialId] || 0;
    const evidenciaActual = dataEvidencias?.evidencias?.find(
      (e) => e.material === materialId,
    );
    const actuales = evidenciaActual ? evidenciaActual.fotos.length : 0;
    return actuales > iniciales;
  };

  const generateExcel = async (e) => {
    e.preventDefault();
    const materialesSinFotoNueva = materialesOrden
      .filter((m) => m.materialId !== "")
      .filter((m) => !tieneFotoNueva(m.materialId));

    const totalMateriales = materialesOrden.filter(
      (m) => m.materialId !== "",
    ).length;

    if (materialesSinFotoNueva.length === totalMateriales) {
      await Swal.fire({
        icon: "warning",
        title: "Faltan evidencias",
        text: "Debes tomar al menos una foto nueva en cualquier material para continuar.",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
      return;
    }
    try {
      const result = await Swal.fire({
        title: "Validación pendiente",
        text: "El formato no puede editarse hasta que se complete la validación.",
        icon: "warning",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
      });
      if (!result.isConfirmed) return;
      setLoading(true);
      // Genera los archivos en el backend
      await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/generarFormatoExcel`,
        { idOrder: orderSelected, tipoReporte: tipoReporte },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: process.env.REACT_APP_APIKEY,
          },
        },
      );
      setLoading(false);
      // Descarga primer archivo
      Swal.fire({
        icon: "success",
        title: "Formato generado correctamente",
        text: "El formato de entrega se ha guardado exitosamente.",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          closeUpdateReporte();
          setLoading(false);
          getAllOrdenesMongo();
        }
      });
    } catch (error) {
      setLoading(false);
      console.log("Ocurrió un error al obtener los archivos: ", error);
    }
  };

  const downloadOrderPdf = async (idOrder, tipoReporte) => {
    try {
      setLoading(true);

      // Paso 1: Generar el token
      const tokenResponse = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/generarTokenPdf`,
        { idOrder },
        { withCredentials: true },
      );

      const tokenTemporal = tokenResponse.data.tokenTemporal;

      // Paso 2: Descargar el PDF usando el token
      const response = await axios.get(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getPdfProtegido/${tipoReporte}`,
        {
          headers: {
            "x-temporal-token": tokenTemporal,
          },
          responseType: "blob", // Importante para descargar archivos
        },
      );

      // Paso 3: Determinar el nombre del archivo según el tipo de reporte
      let nombreArchivo = "";
      if (tipoReporte === "1") {
        nombreArchivo = `Reporte_Recepcion_${idOrder}.pdf`;
      } else if (tipoReporte === "2") {
        nombreArchivo = `Reporte_24H_${idOrder}.pdf`;
      } else if (tipoReporte === "3") {
        nombreArchivo = `Reporte_48H_${idOrder}.pdf`;
      }

      // Paso 4: Crear URL temporal del blob y descargar
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nombreArchivo);
      document.body.appendChild(link);
      link.click();

      // Paso 5: Limpiar
      link.remove();
      window.URL.revokeObjectURL(url);

      setLoading(false);

      Swal.fire({
        icon: "success",
        title: "Descarga exitosa",
        text: "El PDF se ha descargado correctamente",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      setLoading(false);
      console.error("Error al descargar PDF:", error);

      // Manejo de errores más específico
      let mensajeError = "No se pudo descargar el PDF. Intenta nuevamente.";

      if (error.response) {
        if (error.response.status === 403) {
          mensajeError =
            "Token inválido o expirado. Por favor intenta de nuevo.";
        } else if (error.response.status === 404) {
          mensajeError = "No se encontró el PDF solicitado.";
        }
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: mensajeError,
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const getBadgePorDocumento = (item, tipoTxt) => {
    let comentarios = [];
    if (rol === "ADMIN" || rol === "SUPERVISOR") {
      comentarios = [
        ...(item.comentariosStore || []),
        ...(item.comentariosProvider || []),
      ];
    }

    if (rol === "STORE") {
      comentarios = item.comentariosStore || [];
    }

    if (rol === "PROVIDER") {
      comentarios = item.comentariosProvider || [];
    }

    const comentariosDoc = comentarios.filter(
      (c) => String(c.tipoDocumento) === String(tipoTxt),
    );

    if (rol === "ADMIN" || rol === "SUPERVISOR") {
      return comentariosDoc.filter((c) => !c.leidoPorAdmin).length;
    }

    if (rol === "STORE") {
      return comentariosDoc.filter((c) => !c.leidoPorStore).length;
    }

    if (rol === "PROVIDER") {
      return comentariosDoc.filter((c) => !c.leidoPorProvider).length;
    }

    return 0;
  };

  return (
    <>
      <Box
        sx={{
          width: "95%",
          margin: "2rem auto",
          display: "flex",
          flexDirection: "column",
          gap: 3,
          height: "100%",
        }}>
        <Cliploader loading={loading} />

        <Typography
          variant="h6"
          justifyContent="center"
          color="#00205b"
          style={styles.titleaux}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}>
            &nbsp;&nbsp; BUSCADOR REPORTES DE RECEPCIÓN&nbsp;&nbsp;{" "}
          </div>
        </Typography>

        <Paper
          sx={{
            display: "flex",
            alignItems: "center",
            p: 1,
            maxWidth: 600,
            margin: "0 auto",
            boxShadow: 3,
            borderRadius: 2,
          }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Buscar"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Paper>
        <Paper
          sx={{
            width: "100%",
            overflowX: "auto",
            boxShadow: 3,
            borderRadius: 2,
          }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.3rem",
                marginTop: "1rem",
                fontFamily: "Petco Circular CAP Web Black",
                margin: "1rem",
              }}>
              <Cliploader color="#00205B" size="3rem" />
            </div>
          ) : dataReportesFilter && dataReportesFilter.length === 0 ? (
            <Typography sx={{ p: 2 }}>No hay reportes disponibles</Typography>
          ) : (
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className="thead-buscador">Orden</TableCell>
                  <TableCell className="thead-buscador">
                    <div className="div-thead-buscador">
                      <div>
                        <label>Tienda destino</label>
                        <select
                          value={filtroTienda}
                          onChange={(e) => setFiltroTienda(e.target.value)}>
                          <option value="">Todas</option>
                          {tiendasUnicas.map((tienda) => (
                            <option key={tienda} value={tienda}>
                              {tienda}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="thead-buscador">
                    <div className="div-thead-buscador">
                      <div>
                        <label>Proveedor</label>
                        {(rol === "ADMIN" ||
                          rol === "SUPERVISOR" ||
                          rol === "STORE" ||
                          rol === "GPI") && (
                          <select
                            value={selectedProveedor}
                            onChange={(e) =>
                              setSelectedProveedor(e.target.value)
                            }>
                            <option value="">Todas</option>
                            {proveedoresUnicos.map((proveedor) => (
                              <option key={proveedor} value={proveedor}>
                                {proveedor}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="thead-buscador">
                    <div className="div-thead-buscador">
                      Fecha recepción
                      <svg
                        onClick={ordenarPorFecha}
                        style={{ cursor: "pointer" }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#000000"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M3 9l4 -4l4 4m-4 -4v14" />
                        <path d="M21 15l-4 4l-4 -4m4 4v-14" />
                      </svg>
                    </div>
                  </TableCell>
                  {rol !== "PROVIDER" && (
                    <TableCell className="thead-buscador">
                      Elaborado por
                    </TableCell>
                  )}
                  <TableCell className="thead-buscador">
                    <div className="div-thead-buscador">
                      <div>
                        <label>Reporte de recepción: </label>
                        <select
                          value={selectedEstatuxTxt1}
                          onChange={(e) =>
                            setSelectedEstatusTxt1(e.target.value)
                          }>
                          <option value="*">Todos</option>
                          {estatuxTxt1Unicos.map((opt) => (
                            <option
                              key={opt.value || "vacio"}
                              value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="thead-buscador">
                    <div className="div-thead-buscador">
                      <div>
                        <label>Validación 24 horas: </label>
                        <select
                          value={selectedEstatuxTxt2}
                          onChange={(e) =>
                            setSelectedEstatusTxt2(e.target.value)
                          }>
                          <option value="*">Todos</option>
                          {estatuxTxt2Unicos.map((opt) => (
                            <option
                              key={opt.value || "vacio"}
                              value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="thead-buscador">
                    <div className="div-thead-buscador">
                      <div>
                        <label>Validación 48 horas: </label>
                        <select
                          value={selectedEstatuxTxt3}
                          onChange={(e) =>
                            setSelectedEstatusTxt3(e.target.value)
                          }>
                          <option value="*">Todos</option>
                          {estatuxTxt3Unicos.map((opt) => (
                            <option
                              key={opt.value || "vacio"}
                              value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataReportesFilter.map((item) => {
                  const badgeDoc1 = getBadgePorDocumento(item, "RECEPCION");
                  const badgeDoc2 = getBadgePorDocumento(item, "24 HORAS");
                  const badgeDoc3 = getBadgePorDocumento(item, "48 HORAS");
                  const fechaRecepcion = new Date(item.fechaRecepcion);
                  const ahora = new Date();
                  const diffHoras = (ahora - fechaRecepcion) / (1000 * 60 * 60);
                  const validacion24 = diffHoras <= 24 ? "✅" : "❌";
                  const validacion48 = diffHoras <= 48 ? "✅" : "❌";
                  const puedeVerComentario = (estatusOriginal) => {
                    return (
                      (rol === "PROVIDER" && estatusOriginal === "ACEPTADO") ||
                      ((rol === "ADMIN" ||
                        rol === "SUPERVISOR" ||
                        rol === "STORE") &&
                        ["POR REVISAR", "ACEPTADO", "RECHAZADO"].includes(
                          estatusOriginal,
                        ))
                    );
                  };
                  const puedeVerComentario2 = (
                    estatusAnterior,
                    estatusOriginal,
                  ) => {
                    return (
                      (rol === "PROVIDER" && estatusOriginal === "ACEPTADO") ||
                      ((rol === "ADMIN" ||
                        rol === "SUPERVISOR" ||
                        rol === "STORE") &&
                        ["POR REVISAR", "ACEPTADO", "RECHAZADO"].includes(
                          estatusOriginal,
                        ) &&
                        estatusAnterior === "ACEPTADO")
                    );
                  };
                  const puedeVerPdf = (estatus) => {
                    return (
                      (rol === "PROVIDER" && estatus === "ACEPTADO") ||
                      (rol !== "PROVIDER" &&
                        estatus !== "" &&
                        estatus !== "EN PROCESO")
                    );
                  };

                  const puedeEditar = (estatus1, estatus2) => {
                    const validos = ["", "EN PROCESO", "RECHAZADO"];
                    return (
                      estatus1 === "ACEPTADO" && validos.includes(estatus2)
                    );
                  };

                  const puedeEditar2 = (
                    estatus1,
                    estatus2,
                    tipoSubcategoria,
                  ) => {
                    const validos = ["", "EN PROCESO", "RECHAZADO"];
                    const tipoMaterial = ["AMBOS", "48 HORAS"];
                    return (
                      estatus1 === "ACEPTADO" &&
                      validos.includes(estatus2) &&
                      tipoMaterial.includes(tipoSubcategoria)
                    );
                  };

                  return (
                    <TableRow key={item.idOrder} hover>
                      <TableCell className="tbody-buscador">
                        <div className="div-order-table">
                          <span>{item.idOrder}</span>
                          {item.tieneManual ? "🖐(manual)" : ""}
                        </div>
                      </TableCell>
                      <TableCell className="tbody-buscador">
                        {item.tiendaDestino}
                      </TableCell>
                      <TableCell className="tbody-buscador">
                        {item.proveedorText}
                      </TableCell>
                      <TableCell className="tbody-buscador">
                        {new Date(item.fechaCreacion).toLocaleString("es-MX", {
                          dateStyle: "short",
                          timeStyle: "medium",
                        })}
                      </TableCell>
                      {rol !== "PROVIDER" && (
                        <TableCell className="tbody-buscador">
                          {item.noemp ? item.noemp.split("-")[1] : ""}
                        </TableCell>
                      )}
                      <TableCell
                        className="tbody-buscador"
                        style={getEstatusStyles(item.estatusTxt1)}>
                        <div className="div-reporte-inicio">
                          {(rol === "ADMIN" ||
                            rol === "SUPERVISOR" ||
                            rol === "GPI") &&
                            (item.estatusTxt1
                              ? item.estatusTxt1
                              : "NO SE HA GENERADO")}

                          {rol === "PROVIDER" &&
                            (item.estatusTxt1 === "ACEPTADO"
                              ? item.estatusTxt1
                              : "NO SE HA GENERADO")}

                          {rol === "STORE" &&
                            (item.estatusTxt1 ? item.estatusTxt1 : "")}

                          {rol === "STORE" &&
                            (item.estatusTxt1 === "EN PROCESO" ||
                              item.estatusTxt1 === "RECHAZADO") && (
                              <svg
                                onClick={() => {
                                  if (
                                    item.estatusTxt1 === "EN PROCESO" ||
                                    item.estatusTxt1 === "RECHAZADO"
                                  ) {
                                    navigate(
                                      `/reporterecepcionExcel/${item.idOrder}`,
                                    );
                                  }
                                }}
                                style={{ cursor: "pointer" }}
                                width="26"
                                height="26"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#616161"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                <path d="M16 5l3 3" />
                              </svg>
                            )}

                          <div className="div-btn-center">
                            {puedeVerPdf(item.estatusTxt1) && (
                              <svg
                                /*onClick={() => {
                                  setOrdenSeleccionada(item.idOrder);
                                  setMostrarViewer(true);
                                  setTipoReporte("1");
                                }}*/
                                onClick={() => {
                                  handleViewDisclaimer(item.idOrder, "1");
                                }}
                                style={{ cursor: "pointer" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#616161"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round">
                                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                              </svg>
                            )}

                            {puedeVerComentario(item.estatusTxt1) && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenComentarios(true);
                                  setOrdenSeleccionada(item.idOrder);
                                  setTipoReporte("1");
                                }}>
                                <Badge
                                  badgeContent={badgeDoc1}
                                  color="error"
                                  overlap="circular">
                                  <CommentIcon fontSize="small" />
                                </Badge>
                              </IconButton>
                            )}
                          </div>
                        </div>
                      </TableCell>

                      <TableCell
                        className="tbody-buscador"
                        style={getEstatusStyles(item.estatusTxt2)}>
                        {/*validacion24*/}
                        <div className="div-reporte-inicio">
                          {(rol === "ADMIN" ||
                            rol === "SUPERVISOR" ||
                            rol === "GPI") &&
                            (item.estatusTxt2
                              ? item.estatusTxt2
                              : "NO SE HA GENERADO")}

                          {rol === "PROVIDER" &&
                            (item.estatusTxt2 === "ACEPTADO"
                              ? item.estatusTxt2
                              : "NO SE HA GENERADO")}

                          {rol === "STORE" && (
                            <div className="div-btn-center">
                              <p
                                style={{
                                  color: puedeEditar(
                                    item.estatusTxt1,
                                    item.estatusTxt2,
                                  )
                                    ? "black"
                                    : "gray",
                                  fontWeight:
                                    item.estatusTxt1 === "ACEPTADO" &&
                                    item.estatusTxt2 === ""
                                      ? "bold"
                                      : "",
                                }}>
                                {rol === "STORE" && item.estatusTxt2
                                  ? item.estatusTxt2
                                  : "GENERAR"}
                              </p>

                              {puedeEditar(
                                item.estatusTxt1,
                                item.estatusTxt2,
                              ) && (
                                <svg
                                  onClick={() => {
                                    const reporte48Bloqueante = [
                                      "EN PROCESO",
                                      "POR REVISAR",
                                      "RECHAZADO",
                                      "ACEPTADO",
                                      "VENCIDO",
                                    ];
                                    if (
                                      reporte48Bloqueante.includes(
                                        item.estatusTxt3,
                                      )
                                    ) {
                                      Swal.fire({
                                        icon: "warning",
                                        title: "Reporte de 48 horas en curso",
                                        text: "El reporte de 24 horas ya no puede editarse porque el reporte de 48 horas ya está en proceso.",
                                        confirmButtonColor: "#00205B",
                                        confirmButtonText: "Aceptar",
                                      });
                                      return;
                                    }
                                    openUpdateReporte(item.idOrder, "2");
                                  }}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="26"
                                  height="26"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#616161"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round">
                                  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                  <path d="M16 5l3 3" />
                                </svg>
                              )}
                            </div>
                          )}

                          <div className="div-btn-center">
                            {puedeVerPdf(item.estatusTxt2) && (
                              <svg
                                /*onClick={() => {
                                  setOrdenSeleccionada(item.idOrder);
                                  setMostrarViewer(true);
                                  setTipoReporte("2");
                                }}*/
                                onClick={() => {
                                  handleViewDisclaimer(item.idOrder, "2");
                                }}
                                style={{ cursor: "pointer" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#616161"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round">
                                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                              </svg>
                            )}

                            {puedeVerComentario2(
                              item.estatusTxt1,
                              item.estatusTxt2,
                            ) && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenComentarios(true);
                                  setOrdenSeleccionada(item.idOrder);
                                  setTipoReporte("2");
                                }}>
                                <Badge
                                  badgeContent={badgeDoc2}
                                  color="error"
                                  overlap="circular">
                                  <CommentIcon fontSize="small" />
                                </Badge>
                              </IconButton>
                            )}
                          </div>
                        </div>
                      </TableCell>

                      <TableCell
                        className="tbody-buscador"
                        style={getEstatusStyles(item.estatusTxt3)}>
                        {/*validacion48*/}
                        <div className="div-reporte-inicio">
                          {(rol === "ADMIN" ||
                            rol === "SUPERVISOR" ||
                            rol === "GPI") &&
                            (item.estatusTxt3
                              ? item.estatusTxt3
                              : "NO SE HA GENERADO")}

                          {rol === "PROVIDER" &&
                            (item.estatusTxt3 === "ACEPTADO"
                              ? item.estatusTxt3
                              : "NO SE HA GENERADO")}

                          {rol === "STORE" && (
                            <div className="div-btn-center">
                              <p
                                style={{
                                  color: puedeEditar2(
                                    item.estatusTxt1,
                                    item.estatusTxt3,
                                    item.tipoSubcategoria,
                                  )
                                    ? "black"
                                    : "gray",
                                  fontWeight:
                                    item.estatusTxt1 === "ACEPTADO" &&
                                    item.estatusTxt3 === "" &&
                                    (item.tipoSubcategoria === "48 HORAS" ||
                                      item.tipoSubcategoria === "AMBOS")
                                      ? "bold"
                                      : "",
                                }}>
                                {item.estatusTxt3
                                  ? item.estatusTxt3
                                  : "GENERAR"}
                              </p>

                              {puedeEditar2(
                                item.estatusTxt1,
                                item.estatusTxt3,
                                item.tipoSubcategoria,
                              ) && (
                                <svg
                                  onClick={() => {
                                    const reporte24Bloqueante = [
                                      "EN PROCESO",
                                      "RECHAZADO",
                                      "POR REVISAR",
                                    ];
                                    if (
                                      reporte24Bloqueante.includes(
                                        item.estatusTxt2,
                                      )
                                    ) {
                                      Swal.fire({
                                        icon: "warning",
                                        title: "Reporte de 24 horas pendiente",
                                        text: "El reporte de 48 horas no puede editarse hasta que el reporte de 24 horas sea aceptado.",
                                        confirmButtonColor: "#00205B",
                                        confirmButtonText: "Aceptar",
                                      });
                                      return;
                                    }
                                    openUpdateReporte(item.idOrder, "3");
                                  }}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="26"
                                  height="26"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#616161"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round">
                                  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                  <path d="M16 5l3 3" />
                                </svg>
                              )}
                            </div>
                          )}

                          <div className="div-btn-center">
                            {puedeVerPdf(item.estatusTxt3) && (
                              <svg
                                /*onClick={() => {
                                  setOrdenSeleccionada(item.idOrder);
                                  setMostrarViewer(true);
                                  setTipoReporte("3");
                                }}*/
                                onClick={() => {
                                  handleViewDisclaimer(item.idOrder, "3");
                                }}
                                style={{ cursor: "pointer" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#616161"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round">
                                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                              </svg>
                            )}
                            {puedeVerComentario2(
                              item.estatusTxt1,
                              item.estatusTxt3,
                            ) && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenComentarios(true);
                                  setOrdenSeleccionada(item.idOrder);
                                  setTipoReporte("3");
                                }}>
                                <Badge
                                  badgeContent={badgeDoc3}
                                  color="error"
                                  overlap="circular">
                                  <CommentIcon fontSize="small" />
                                </Badge>
                              </IconButton>
                            )}
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}

          <ComentariosModal
            open={openComentarios}
            cantComentarios={cantComentarios}
            setCantComentarios={setCantComentarios}
            rol={rol}
            tipoReporte={tipoReporte}
            idOrder={ordenSeleccionada}
            handleClose={() => {
              setOpenComentarios(false);
              setTipoReporte("");
              setOrdenSeleccionada("");
              getAllOrdenesMongo();
              setCantComentarios(0);
            }}
          />
          {ordenSeleccionada && viewDisclaimerOpen && (
            <PdfReporteViewer
              tipoReporte={tipoReporte}
              idOrder={ordenSeleccionada}
              open={viewDisclaimerOpen}
              onClose={handleCloseDisclaimer}
              /*onClose={() => {
                setMostrarViewer(false);
                setTipoReporte("");
              }}*/
            />
          )}
        </Paper>
      </Box>

      {viewModal && (
        <div className="overlay-guia">
          <div className="popup-ordenes">
            <div className="btn-cerrar-popup">
              <span
                style={{ cursor: "pointer" }}
                onClick={closeUpdateReporte}
                title="Cerrar Ventana">
                x
              </span>
            </div>

            <p className="title-reporte">
              {tipoReporte === "2"
                ? "REPORTE DE RECEPCION DE 24 HORAS"
                : tipoReporte === "3"
                  ? "REPORTE DE RECEPCION DE 48 HORAS"
                  : ""}
            </p>

            {!infoUpdated ? (
              <div className="div-content-modal">
                <Cliploader loading={loading} />

                <TableContainer
                  className="container-table-modal"
                  sx={{
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#ABABAB",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#888",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#f1f1f1",
                    },
                    "& .MuiTableCell-root": {
                      fontSize: {
                        xs: "7px",
                        sm: "9px",
                        md: "11px",
                      },
                    },
                  }}
                  /*sx={{
            maxHeight: {
              xs: "280px",
              sm: "210px",
              md: "300px",
              lg: "280px",
              xl: "500px",
            },
            marginTop: 2,
            overflowY: "scroll",
          }}*/
                >
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        {columns.map((col, index) => (
                          <Tooltip
                            key={index}
                            title={col}
                            arrow
                            placement="top"
                            enterDelay={600}
                            leaveDelay={100}>
                            <TableCell id="thead-reporte">{col}</TableCell>
                          </Tooltip>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {currentRows &&
                        currentRows.map((row, rowIndex) => (
                          <TableRow key={rowIndex}>
                            {columns2
                              .filter((col) => col !== "manual")
                              .map((col, colIndex) => {
                                const value = row[col] ?? "";
                                //console.log("ROW", row);
                                //console.log("COL", [col]);
                                //console.log("COL INDEX", colIndex);
                                //console.log("VALUE", value);
                                const isManual = row.manual;
                                const tieneError =
                                  erroresTabla?.[`${rowIndex}-${col}`];

                                const backgroundColor =
                                  col === "noAptos"
                                    ? "lightpink"
                                    : col === "faltantesFacturados"
                                      ? "#F9FC6A"
                                      : col === "cantidadRecibidos"
                                        ? "lightgreen"
                                        : "transparent";

                                if (col === "problemas") {
                                  return (
                                    <TableCell
                                      className="styles-celdas"
                                      id="check-problemas"
                                      key={colIndex}>
                                      <Checkbox
                                        checked={!!row.habilitarEdicion}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            rowIndex,
                                            e.target.checked,
                                          )
                                        }
                                      />
                                    </TableCell>
                                  );
                                }
                                // Celda especial: “PROBLEMAS EN RECEPCION”
                                if (col === "problemasEnRecepcion") {
                                  return (
                                    <Tooltip
                                      key={colIndex}
                                      title={value}
                                      arrow
                                      placement="top"
                                      enterDelay={600}
                                      leaveDelay={100}>
                                      <TableCell className="styles-celdas">
                                        <Select
                                          fullWidth
                                          size="small"
                                          error={tieneError}
                                          sx={{
                                            height: "25px",
                                            maxWidth: "80px",
                                            fontSize: "11px",
                                          }}
                                          value={value}
                                          onChange={(e) =>
                                            handleChange(
                                              rowIndex,
                                              col,
                                              e.target.value,
                                            )
                                          }
                                          disabled={!row.habilitarEdicion}>
                                          {catalogoProblms.map((p, i) => (
                                            <MenuItem
                                              key={i}
                                              value={p.problemaText}>
                                              {p.problemaText}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </TableCell>
                                    </Tooltip>
                                  );
                                }
                                return (
                                  <Tooltip
                                    key={colIndex}
                                    title={value}
                                    arrow
                                    placement="top"
                                    enterDelay={600}
                                    leaveDelay={100}>
                                    <TableCell
                                      className="styles-celdas"
                                      sx={{
                                        //border: "solid 0.1px",
                                        backgroundColor,
                                      }}>
                                      {isManual && colIndex == 0 && (
                                        <span
                                          style={{
                                            left: 2,
                                            top: 2,
                                            fontSize: "10px",
                                            color: "#FFC107",
                                            fontWeight: "bold",
                                          }}>
                                          ⭐ Manual
                                        </span>
                                      )}
                                      {isManual && colIndex == 2 && (
                                        <span
                                          style={{
                                            left: 2,
                                            top: 2,
                                            fontSize: "10px",
                                            color: "#FFC107",
                                            fontWeight: "bold",
                                          }}>
                                          Adicionales
                                        </span>
                                      )}

                                      <TextField
                                        sx={{
                                          "& .MuiInputBase-input": {
                                            fontSize: "11px",
                                            padding: "4px",
                                            backgroundColor: tieneError
                                              ? "#ffebee"
                                              : "transparent",
                                          },
                                          "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                              borderColor: tieneError
                                                ? "red"
                                                : undefined,
                                            },
                                          },
                                          paddingLeft:
                                            isManual && colIndex === 0
                                              ? "11px"
                                              : "4px",
                                        }}
                                        value={value}
                                        onChange={(e) =>
                                          handleChange(
                                            rowIndex,
                                            col,
                                            e.target.value,
                                          )
                                        }
                                        disabled={
                                          col === "materialId" ||
                                          col === "materialDescripcion" ||
                                          col === "piezasPedidas" ||
                                          col === "costoUnitario" ||
                                          col === "cantidadRecibidos" ||
                                          (!row.habilitarEdicion &&
                                            [
                                              "diagnostico",
                                              "tratamiento",
                                              "comentariosGenerales",
                                              "noAptos",
                                            ].includes(col))
                                        }
                                      />
                                    </TableCell>
                                  </Tooltip>
                                );
                              })}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                  {rows.length === 0 && !loading && (
                    <Box
                      sx={{
                        textAlign: "center",
                        padding: 2,
                        color: "gray",
                        border: "1px solid lightgray",
                        borderTop: "none",
                      }}>
                      No hay datos
                    </Box>
                  )}
                </TableContainer>

                {rows.length > 0 && (
                  <Box display="flex" justifyContent="center" mt={1} gap={1}>
                    {currentPage > 1 && (
                      <Button onClick={() => setCurrentPage(currentPage - 1)}>
                        Anterior
                      </Button>
                    )}
                    <span>
                      Página {currentPage} de {totalPages}
                    </span>
                    {currentPage < totalPages && (
                      <Button onClick={() => setCurrentPage(currentPage + 1)}>
                        Siguiente
                      </Button>
                    )}
                  </Box>
                )}

                <div className="div-btn-order">
                  <span
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => setNewMaterialSelected(true)}>
                    Agregar nuevo material
                  </span>
                  {!loading ? (
                    <CustomButton
                      variant="contained"
                      onClick={handleSaveData}
                      style={{
                        cursor: "pointer",
                        width: "20%",
                      }}
                      type="submit">
                      SIGUIENTE
                    </CustomButton>
                  ) : (
                    <CircularProgress />
                  )}
                  <span />
                </div>

                {newMaterialSelected && (
                  <div>
                    <div className="grid-form">
                      <TextField
                        size="small"
                        name="materialId"
                        label="Material Id"
                        value={formData.materialId}
                        error={errorFormData.materialId}
                        onChange={handleFormMaterial}
                        onBlur={handleBuscarDescripcion}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        size="small"
                        name="materialDescripcion"
                        disabled
                        label="Material descripción"
                        value={formData.materialDescripcion}
                        error={errorFormData.materialDescripcion}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        size="small"
                        name="piezasPedidas"
                        label="Piezas pedidas"
                        value={formData.piezasPedidas}
                        error={errorFormData.piezasPedidas}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        size="small"
                        name="costoUnitario"
                        label="Costo unitario"
                        value={formData.costoUnitario}
                        error={errorFormData.costoUnitario}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        size="small"
                        name="facturados"
                        label="Facturados"
                        value={formData.facturados}
                        error={errorFormData.facturados}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />

                      <TextField
                        size="small"
                        name="noAptos"
                        label="No aptos a la recepción"
                        value={formData.noAptos}
                        error={errorFormData.noAptos}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />

                      <TextField
                        size="small"
                        name="faltantesFacturados"
                        label="Faltantes facturados"
                        value={formData.faltantesFacturados}
                        error={errorFormData.faltantesFacturados}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />

                      <TextField
                        size="small"
                        name="cantidadRecibidos"
                        label="Totales a ingresar"
                        disabled
                        value={formData.cantidadRecibidos}
                        error={errorFormData.cantidadRecibidos}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />

                      <TextField
                        size="small"
                        name="faltantesNoFacturados"
                        label="Faltantes no facturados"
                        value={formData.faltantesNoFacturados}
                        error={errorFormData.faltantesNoFacturados}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />

                      <TextField
                        select
                        fullWidth
                        size="small"
                        name="problemasEnRecepcion"
                        label="Problemas en recepción"
                        error={errorFormData.problemasEnRecepcion}
                        value={formData.problemasEnRecepcion}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                        SelectProps={{ displayEmpty: true }}>
                        <MenuItem disabled value="">
                          <em>Selecciona</em>
                        </MenuItem>
                        {catalogoProblms.map((p, i) => (
                          <MenuItem key={i} value={p.problemaText}>
                            {p.problemaText}
                          </MenuItem>
                        ))}
                      </TextField>

                      <TextField
                        size="small"
                        name="diagnostico"
                        label="Diagnóstico"
                        value={formData.diagnostico}
                        error={errorFormData.diagnostico}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        size="small"
                        name="tratamiento"
                        label="Tratamiento"
                        value={formData.tratamiento}
                        error={errorFormData.tratamiento}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        size="small"
                        name="comentariosGenerales"
                        label="Comentarios generales"
                        value={formData.comentariosGenerales}
                        error={errorFormData.comentariosGenerales}
                        onChange={handleFormMaterial}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>
                    <div className="div-btn-center">
                      <CustomButton
                        variant="contained"
                        onClick={handleSaveMaterial}
                        style={{
                          cursor: "pointer",
                          width: "20%",
                        }}
                        type="submit">
                        AGREGAR
                      </CustomButton>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="div-content-modal">
                <Cliploader loading={loading} />
                <div>
                  <div
                    sx={{ width: "90%", height: "100%", border: "none" }}
                    variant="outlined">
                    <svg
                      style={{
                        cursor: "pointer",
                        marginTop: "-5px",
                        marginBottom: "-10px",
                      }}
                      onClick={() => setInfoUpdated(false)}
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#00205b"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path d="M5 12l14 0" />
                      <path d="M5 12l6 6" />
                      <path d="M5 12l6 -6" />
                    </svg>
                    <p
                      style={{
                        fontSize: "13px",
                        textAlign: "center",
                        padding: "10px",
                        width: "100%",
                        fontWeight: "bold",
                      }}>
                      RECUERDA: ES NECESARIO ENVIAR TU REPORTE DE PECES Y
                      ANIMALES MÁXIMO 48 HORAS DESPUÉS DE RECEPCIÓN Y REPORTE DE
                      ALIMENTO VIVO Y CONGELADO 24 HORAS DESPUÉS DE RECEPCIÓN;
                      MANDA UN REPORTE POR CADA PEDIDO QUE LLEGUE A TU TIENDA
                    </p>

                    <div className="table-ev2">
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          textAlign: "center",
                        }}>
                        <thead>
                          <tr style={{ backgroundColor: "#f5f5f5" }}>
                            <th className="head-table-evidencias">
                              Seleccionar
                            </th>
                            <th className="head-table-evidencias">Material</th>
                            <th className="head-table-evidencias">Evidencia</th>
                            <th className="head-table-evidencias">Fotos</th>
                            <th className="head-table-evidencias">
                              Agregar evidencia
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {materialesOrden
                            .filter((item) => item.materialId !== "")
                            .map((item) => {
                              const evidencia =
                                dataEvidencias?.evidencias?.find(
                                  (e) => e.material === item.materialId,
                                );
                              const tieneEvidencias =
                                evidencia && evidencia.fotos.length > 0;
                              return (
                                <tr
                                  key={item.materialId}
                                  style={{ borderBottom: "1px solid #eee" }}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "8px",
                                    }}>
                                    <input
                                      type="radio"
                                      name="material"
                                      value={item.materialId}
                                      checked={
                                        selectedMaterialFoto === item.materialId
                                      }
                                      /*onChange={() => setSelectedMaterial(item["materialId"])
                                        setSelectedMaterial(item["materialDescripcion"])
                                      }*/
                                      onChange={() => {
                                        setSelectedMaterialFoto(
                                          item.materialId,
                                        );
                                        setSelectedMaterialDescrFoto(
                                          item.materialDescripcion,
                                        );
                                      }}
                                    />
                                  </td>

                                  <td style={{ padding: "8px" }}>
                                    {item.manual ? "🖐 " : ""}
                                    {item.materialId} -{" "}
                                    {item.materialDescripcion}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "8px",
                                    }}>
                                    <span
                                      style={{
                                        color: tieneEvidencias
                                          ? "green"
                                          : "red",
                                        fontWeight: "bold",
                                      }}>
                                      {tieneEvidencias
                                        ? "Cargada"
                                        : "Cargar evidencia"}
                                    </span>
                                  </td>
                                  <td style={{ padding: "8px" }}>
                                    {tieneEvidencias ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "4px",
                                          flexWrap: "wrap",
                                        }}>
                                        {evidencia.fotos.map((url, i) => (
                                          <figure
                                            key={i}
                                            style={{
                                              margin: 0,
                                              textAlign: "center",
                                            }}>
                                            <img
                                              src={url.url}
                                              alt={`evidencia-${i}`}
                                              style={{
                                                width: "50px",
                                                height: "35px",
                                                objectFit: "cover",
                                                borderRadius: "4px",
                                                display: "block",
                                              }}
                                            />
                                            <figcaption
                                              style={{
                                                fontSize: "10px",
                                                color: "#555",
                                              }}>
                                              {url.descripcionFoto}
                                            </figcaption>
                                          </figure>
                                        ))}
                                      </div>
                                    ) : (
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          color: "#666",
                                        }}>
                                        Sin evidencias cargadas
                                      </span>
                                    )}
                                  </td>

                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "8px",
                                      cursor: "pointer",
                                    }}>
                                    <svg
                                      style={{ cursor: "pointer" }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="40"
                                      height="40"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#00205B"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      onClick={() => {
                                        setSelectedMaterialFoto(
                                          item.materialId,
                                        );
                                        setSelectedMaterialDescrFoto(
                                          item.materialDescripcion,
                                        );
                                        setMostrarCamara(true);
                                      }}>
                                      <path d="M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5" />
                                      <path d="M16 19h6" />
                                      <path d="M19 16v6" />
                                      <path d="M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                                    </svg>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {mostrarCamara && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 2000,
                      }}>
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "400px",
                          background: "white",
                          borderRadius: "10px",
                          padding: "1rem",
                          position: "relative",
                        }}>
                        <svg
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            cursor: "pointer",
                          }}
                          onClick={() => setMostrarCamara(false)}
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ff3b30"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round">
                          <path d="M10 10l4 4m0 -4l-4 4" />
                          <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
                        </svg>
                        <CamaraComponent
                          selectedMaterial={selectedMaterialFoto}
                          selectedMaterialDescr={selectedMaterialDescrFoto}
                          opt={tipoReporte}
                          orderId={orderSelected}
                          mongoData={dataEvidencias}
                          onClose={() => setMostrarCamara(false)}
                          onPhotosChange={() => {
                            getOrdenInfo(orderSelected);
                          }}
                        />
                      </div>
                    </div>
                  )}

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "20px",
                    }}>
                    <CustomButton
                      onClick={generateExcel}
                      style={{
                        cursor: "pointer",
                        width: "20%",
                      }}>
                      Enviar para validación
                    </CustomButton>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.users.data,
});

const creators = {
  logout: Creators.logout,
  login: Creators.login,
  loginCookies: Creators.loginCookies,
};

export default connect(mapStateToProps, creators)(PassForm);
